import TermsComp from "components/TermsComp";
import { useRouter } from "src/hooks/useRouter";

const TermsCompPage: React.FC = () => {
  const { goLogin } = useRouter();
  return (
    <>
      <div className="loginBody">
        <div className="top">
          <a onClick={goLogin}>
            <div className="icon_fasoo main" />
          </a>
        </div>
      </div>
      <TermsComp></TermsComp>
    </>
  );
};

export default TermsCompPage;
